<template>
    <div>
        <ui-form-field
            label="Выберите город"
            :value="city"
            class="_mb-32-16"
        >
            <d-select-search-stable
                :list="selectList"
                v-model="city"
                dark
                :singleLine="false"
            />
        </ui-form-field>
        <template
            v-for="(item, i) in selectedItem.items"
        >
            <div :key="`${i}-address`" class="h3 _mb-8 text-align-left-center _mt-32">
                {{ item.address }}
            </div>
            <div :key="`${i}-operating`" class="p1 gray-text-light text-align-left-center">
                {{ item.operating1 }}<br>
                {{ item.operating2 }}
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "privateContacts",
        props: {
            points: {
                type: Array,
                default: () => { return [] }
            }
        },
        data() {
            return {
                city: 'msc',
            }
        },
        computed: {
            selectedItem() {
                return this.points?.find((item) => item.code === this.city) ?? {};
            },
            selectList() {
                return this.points.map(point => {
                    return {
                        const: point.code,
                        title: point.title,
                    };
                }).sort((a, b) => a.title.localeCompare(b.title));
            }
        },
    };
</script>
